<template>
  <div class="action-button mute" @click="$emit('click')">
    <i class="action-icon fal fa-volume-mute"></i>
    <p class="action-text">Silenciar usuario</p>
  </div>
</template>

<script>
export default {
  name: 'edi-mute-comment-btn',
}
</script>
